/* eslint-disable react/jsx-key */
import React from 'react';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { InquiryMessages } from './components/InquiryMessages';

export const RolexSettings = () => {
  return (
    <StandardLayoutV2
      title="Rolex Inquiry"
      classProps="flex-col-left"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent' }}
    >
      <InquiryMessages />
    </StandardLayoutV2>
  );
};
